import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {DomainEntity} from './domain.entity';
import {LayerSystemXrefEntity} from './layer.system.xref.entity';
import {LayoutSystemXrefEntity} from './layout.system.xref.entity';
import {SystemEntity} from './system.entity';

@EntityTable('route', '88bd5f2e-baf9-4a8e-a3cc-9c58cac1372e')
export class RouteEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.STRING)
    public path: string;

    @Column(FieldTypeKind.STRING)
    public hash: string;

    @Column(FieldTypeKind.LONG)
    public segments: number;

    @Column(FieldTypeKind.ANY)
    public condition: any;

    @Column(FieldTypeKind.DECIMAL)
    public weight: number;

    @Column(FieldTypeKind.BOOLEAN)
    public isRoot: boolean;

    @JoinColumn(FieldTypeKind.GUID, RouteEntity, true, false, FieldRelationKind.BELONGS_TO, 'redirectRoute', 'aliasId', 'redirectId')
    public redirectId: string;

    @JoinColumn(FieldTypeKind.GUID, LayoutSystemXrefEntity, true, false, FieldRelationKind.BELONGS_TO, 'layoutSystemXref', 'aliasId', 'layoutSystemId')
    public layoutSystemId: string;

    @JoinColumn(FieldTypeKind.GUID, LayerSystemXrefEntity, true, false, FieldRelationKind.BELONGS_TO, 'layerSystemXref', 'aliasId', 'layerSystemId')
    public layerSystemId: string;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, false, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

    @JoinColumn(FieldTypeKind.GUID, DomainEntity, true, false, FieldRelationKind.BELONGS_TO, 'domain', 'aliasId', 'domainId')
    public domainId: string;

    @Transient()
    public layoutSystemXref: LayoutSystemXrefEntity;

    @Transient()
    public layerSystemXref: LayerSystemXrefEntity;

    @Transient()
    public redirectRoute: RouteEntity;

    @Transient()
    public domain: DomainEntity;

    @Transient()
    public params: Map<string, string> = new Map<string, string>();

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

}
